import { CompareProducts } from '@iheartjane/menu';
import type { ReactNode } from 'react';

import type { MobileFiltersModalProps } from '@jane/bloom/components/productListingPage/categoryAndFilterSelectors/filterSelector/mobileFiltersModal';
import { MobileFiltersModal } from '@jane/bloom/components/productListingPage/categoryAndFilterSelectors/filterSelector/mobileFiltersModal';

import styles from './mobileFilterRow.module.css';

interface MobileFilterRowProps extends MobileFiltersModalProps {
  actionSlot?: ReactNode;
  showCompare?: boolean;
}

export function MobileFilterRow({
  actionSlot,
  showCompare = false,
  ...props
}: MobileFilterRowProps) {
  return (
    <div className={styles['mobileFilterRow']}>
      <MobileFiltersModal {...props} />
      {actionSlot && (
        <div className={styles['mobileActionSlot']}>{actionSlot}</div>
      )}
      {showCompare && <CompareProducts.Button />}
    </div>
  );
}
